import { useEffect, useState } from "react";
import { FormProvider } from "react-hook-form";
import FusePageCarded from "@fuse/core/FusePageCarded";
import { useSelector } from "react-redux";
import socketConfig from "src/socketConfig";
import TextComponent from "./textComponent";

const SocketComponent = () => {
  const { connectToWS, sendPrompt, closeWS, isConnected,initializeAvatarSession,sessionData ,handleStreamReady} = socketConfig(); 
  const language = useSelector((state) => state.fuse.conversations.language)
  const messages = useSelector((state) => state.fuse.conversations.messages); 
  const channel = useSelector((state) => state.fuse.conversations.channel);

   useEffect(() => {
      if (language?.agent_id) {
        connectToWS(language); 
      }
    }, [language]);

    useEffect(() => {
      if (channel=='ai_avatar'&& sessionData) {
        connectToWS(language); 
        handleStreamReady()
      }
    }, [sessionData]);
  
  return (
    <FormProvider>
      <FusePageCarded
        content={
          <div className="p-16 sm:p-24 w-full">
            <TextComponent 
              sendPrompt={sendPrompt}
              closeWS={closeWS}
              isConnected={isConnected}
              messages={messages}
              language={language}
              initializeAvatarSession={initializeAvatarSession}
            />
          </div>
        }
      />
    </FormProvider>
  );
};

export default SocketComponent;
